import React, { useEffect, useState, useRef } from "react";
import SwiperCore, { Navigation, Autoplay, Parallax, EffectFade, Keyboard } from "swiper";
import { SwiperContainer } from "./SwiperElements";
import { Swiper } from "swiper/react";
import { CreateSlides } from "./actions";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/effect-fade/effect-fade.scss";
import "swiper/components/keyboard";

// install Swiper components
SwiperCore.use([Navigation, Autoplay, Parallax, EffectFade, Keyboard]);

const SwiperSection = ({
  elements,
  swiper,
  setSwiper,
  slideIndex,
  setSlideIndex,
  isLoading,
  setLoading,
  fontColor,
  setFontColor,
  index,
  setIndex,
}) => {
  // eslint-disable-next-line
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [hidden, setHidden] = useState(0);
  

  const inputRef = useRef();
  const whiteFontIndex = [0,2,3,4,5,6,7,9,12,14,15,18,22,25,28,29,36,38,42,43,44];


  const vidRef=useRef();

  useEffect(() => { vidRef.current.pause(); },[]);

  useEffect(() => {
    addEventListeners();
    return () => removeEventListeners();
  });

  const addEventListeners = () => {
    document.addEventListener("mousemove", onMouseMove);
  };

  const removeEventListeners = () => {
    document.removeEventListener("mousemove", onMouseMove);
  };

  const onMouseMove = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
    if (inputRef.current) {
      let referencePosition = inputRef.current.getBoundingClientRect();
      let middle =
        referencePosition.left +
        (referencePosition.right - referencePosition.left) / 2;

      if (
        e.clientY > referencePosition.top &&
        e.clientY < referencePosition.bottom
      ) {
        if (e.clientX > referencePosition.left && e.clientX < middle) {
          setHidden(1);
        } else if (e.clientX > middle && e.clientX < referencePosition.right) {
          setHidden(2);
        } else {
          setHidden(0);
        }
      } else {
        setHidden(0);
      }
    }
  };

  const vh = useRef(window.innerHeight).current;
  const vhRedux = vh - vh*0.08
  const vhScreen = '' + vhRedux + 'px'
  

  return (
    <SwiperContainer
      fontColor={fontColor}
      cursor={hidden}
      page={elements.swiper}
      load={isLoading}
      ref={inputRef}
      onClick={() => {
        if (hidden === 2) {
          swiper.slideNext(850);
          swiper.autoplay.start();
        } else if (hidden === 1) {
          swiper.slidePrev(850);
          swiper.autoplay.start();
        }
        
      }}
    >
    
      <Swiper
        modules={[Autoplay, EffectFade]}
        slidesPerView={1}
        autoHeight={true}
        loop={true}
        parallax={true}
        updateOnImagesReady={true}
        initialSlide={slideIndex}
        onSwiper={(swiper) => {
          slideIndex = swiper.activeIndex;
          setSwiper(swiper);
        }}
        onImagesReady={(s) => {
          s.autoplay.start();
          setLoading(false);
        }}
        onSlideChange={(s)=>{
          setIndex(s.activeIndex);
          if (whiteFontIndex.includes(s.activeIndex)){
            setFontColor("white");
          }
          else {
            setFontColor("black");
          }
          if(s.activeIndex === 28){
            vidRef.current.play();
          }
          else {
            vidRef.current.pause();
          }
        }}
        effect="fade"
        fadeEffect={{crossFade: true}}
        keyboard={true}
        speed={850}
        autoplay={{ delay: 4700, disableOnInteraction: false, waitForTransition: true }}
      >
        {CreateSlides(0, 44, fontColor, index, vhScreen, vidRef)}
      </Swiper>
    </SwiperContainer>
  );
};

export default SwiperSection;
